import api from './api';

export async function createOrder(data) {
    return api.post('/order', data);
}

export async function createTicket(data) {
    return api.post('/ticket', data);
}

export async function sendOrderTicketsByEmail(data) {
    return api.post('/send/tickets', data);
}

/* export async function createPaymentIntent(order) {
    return api.post('/secret', order)
} */

export async function createPaymentIntent(data) {
    return api.post('/checkout/stripe/intent', data)
}

export async function completeStripeCheckout(data) {
    return api.post('/checkout/stripe/complete', data)
}

export async function checkTicketAvailable(order) {
    return api.post('/checkavailable', order)
}

export async function updateTicketsAvailable(order) {
    return api.post('/updateqty', order)
}

export async function findCouponByCode(code, event_id) {
    return api.get(`/coupon/code/${code}/${event_id}`);
}

export async function getCheckoutData(data) {
    return api.post('/checkout', data);
}

export async function checkoutPayment(data) {
    return api.post('/checkout/payment', data);
}

export async function getPaymentMethod(data) {
    return api.patch(`/checkout/stripe/payment-method`, data);
}

export async function getStripeCardDataError(data) {
    return api.post('/checkout/error/get-card-data-stripe', data);
}

export async function getDefaultGateway() {
    return api.get(`/default/gateway/groovoo/${0}`);
}